import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PropertyFeesAndTaxesContainerStyled = styled.div`
  .column-appliesTo,
  .column-scope {
    width: 130px;
  }
  .column-channels {
    width: 115px;
  }
  .column-name {
    width: 220px;
  }

  ${mediaQuery.md} {
    .column-appliesTo,
    .column-scope {
      width: 80px;
    }
    .column-channels {
      width: 115px;
    }
    .column-name {
      width: 100px;
    }
  }

  ${mediaQuery.xs} {
    .table {
      min-width: 1000px;
    }
    .column-name {
      width: 200px;
    }
  }
`;
